module.exports = VueCookie;


//////////////////
// WEBPACK FOOTER
// external "VueCookie"
// module id = ybmF
// module chunks = 233